export default __webpack_public_path__ + "static/media/app-merchant.b57f08f6.webp";